import m from "../../geodata/es2015/sloveniaRegionsHigh";
window.am4geodata_sloveniaRegionsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sloveniaRegionsHigh.js
// module id = null
// module chunks = 